var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t\t调岗申请-" + _vm._s(_vm.ruleForm.id != null && _vm.ruleForm.id != '' ? '修改' : '新增'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-row', [_c('el-col', [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px"
    },
    attrs: {
      "label": "调岗人",
      "prop": "staff_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_name", $$v)
      },
      expression: "ruleForm.staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_card", $$v)
      },
      expression: "ruleForm.staff.staff_card"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "现岗位",
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.post_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "post_name", $$v)
      },
      expression: "ruleForm.staff.post_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id == ''),
      expression: "ruleForm.id == null || ruleForm.id == ''"
    }],
    attrs: {
      "label": "目标架构",
      "prop": "project_id"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.ruleForm.organize_temporary_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "organize_temporary_ids", $$v)
      },
      expression: "ruleForm.organize_temporary_ids"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "label": "目标架构",
      "prop": "project_id"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #DCDFE6",
      "width": "48%",
      "border-radius": "5px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$globals.group_name + "/" + _vm.ruleForm.target_organize_name) + "\n                                ")])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "目标岗位",
      "prop": "post_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.post_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "post_id", $$v)
      },
      expression: "ruleForm.post_id"
    }
  }, _vm._l((_vm.ruleForm.gwlist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "现薪酬",
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.nowSalary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "nowSalary", $$v)
      },
      expression: "ruleForm.nowSalary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "目标薪酬",
      "prop": "target_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.ruleForm.target_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "target_salary", $$v)
      },
      expression: "ruleForm.target_salary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "调岗说明",
      "prop": "transfer_explain"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入调岗说明"
    },
    model: {
      value: (_vm.ruleForm.transfer_explain),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "transfer_explain", $$v)
      },
      expression: "ruleForm.transfer_explain"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id == ''),
      expression: "ruleForm.id == null || ruleForm.id == ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t修改\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择调岗人",
      "visible": _vm.dialogVisibles,
      "width": "40%",
      "center": true,
      "close-on-click-modal": true,
      "show-close": false,
      "modal-append-to-body": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60beafe4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygtg/Ygtg_add.vue
// module id = null
// module chunks = 